module.exports = ".guiCanvas {\n  position: relative;\n  z-index: 99;\n  left: 50%; }\n\n.GuiDiv {\n  position: relative;\n  z-index: 98; }\n\n.cvs {\n  position: relative;\n  z-index: 90; }\n\n.dg .main {\n  width: 100px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/StartApp/welcome/start/simulator/panel-wrapper/scene/scene.component.scss
// module id = ./src/app/StartApp/welcome/start/simulator/panel-wrapper/scene/scene.component.scss
// module chunks = main